import loadable from '@loadable/component';

/**
 * Code-split wrapper for FeedbackWidgetContainer — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
export const FeedbackWidgetContainer = loadable(
    /* #__LOADABLE__ */
    () => import('./FeedbackWidgetContainer'),
    {
        resolveComponent: (components) => components.FeedbackWidgetContainer,
        ssr: false,
    }
);
